import { createSelector } from 'reselect'
import * as muiStylesLib from '@material-ui/core/styles'
import { getColorGreySelector, colorWhiteSelector } from '@signal/theme'

// The legacy palette still uses old key names. They should be eventually
// removed in favor of the keys prefixed with `skeleton`
export const legacyPalette = {
  default: {
    primary: 'rgba(80, 80, 80, 0.2)',
    secondary: 'rgba(80, 80, 80, 0.5)'
  },
  inverse: {
    primary: 'rgba(255, 255, 255, 0.3)',
    secondary: 'rgba(255, 255, 255, 0.8)'
  }
}

export const createSkeletonSelector = (colorSelector, alpha) => {
  const libKeys = Object.keys(muiStylesLib)
  const libKey = libKeys.find(key => key === 'alpha') ? 'alpha' : 'fade'
  const fade = muiStylesLib[libKey]
  return createSelector(colorSelector, color => fade(color, alpha))
}

export const createSkeletonColorSelectors = ({
  colorSelector,
  alphaPrimary,
  alphaSecondary
}) => ({
  skeletonDark: createSkeletonSelector(colorSelector, alphaPrimary),
  skeletonPrimary: createSkeletonSelector(colorSelector, alphaSecondary)
})

export const palette = {
  default: createSkeletonColorSelectors({
    colorSelector: getColorGreySelector('dark'),
    alphaPrimary: 0.5,
    alphaSecondary: 0.2
  }),
  inverse: createSkeletonColorSelectors({
    colorSelector: colorWhiteSelector,
    alphaPrimary: 0.8,
    alphaSecondary: 0.3
  })
}
